module.exports = __webpack_public_path__ + "static/media/port_video.f8bdfb16.mov";